import script from "./vehicleAuditList.vue?vue&type=script&setup=true&lang=js"
export * from "./vehicleAuditList.vue?vue&type=script&setup=true&lang=js"

import "./vehicleAuditList.vue?vue&type=style&index=0&id=e1f4f6aa&lang=css"

const __exports__ = script;

export default __exports__